<template></template>
<script>
export default {
    //封装选择器的通用逻辑
    components: {},
    props: {},
    data() {
        return {
            objs: [],
            pageno: 0,
            pagesize: 10,
            selectedObj: null,
            selectedObjId: null,
            selectedObjs: [],
            selectedObjIds: [],
            filter: '',
            showList: false,
            more: true,
            object: null,
            showDetail: false
        }
    },
    mounted() {
        if (this.objs.length === 0)
            //如果已经选择过就不要在弹出时再去获取
            this.search()
    },
    computed: {
        selectedIds() {
            let ids = []
            if (this.selectedObjs) {
                console.log(
                    'selectedids',
                    this.selectedObjs.length,
                    this.selectedObjs
                )
                this.selectedObjs.map((e) => ids.push(e.id))
            }
            return ids
        },
        selectedNames() {
            let namekey = 'name'
            let names = []
            if (this.selectedObjs) {
                this.selectedObjs.map((e) => {
                    console.log(e, namekey, e[namekey])
                    names.push(e[namekey])
                })
            }
            return names.join(',')
        }
    },
    methods: {
        detail(o) {
            //子类实现
        },
        close() {
            this.showList = false
        },
        showObjs() {
            // if (!this.objs)
            this.search() //每次点击都重新加载
            this.showList = true
        },
        reload() {
            this.pageno = 0
            this.objs = []
            this.search()
        },
        search() {
            //子类实现
            return []
        },
        addToSelected(obj) {
            // console.log('addtoselected', this.selectedObjs, obj)
            var eindex = this.selectedObjs.findIndex((e) => e.id == obj.id)
            if (eindex >= 0) {
            } else {
                if (!this.multiple) {
                    this.selectedObjs = []
                }
                this.selectedObjs.push(obj)
            }

            if (!this.multiple) {
                this.confirmSelectedObjs()
            }
        },
        selectObj(id) {
            this.selectedObjId = id
            let obj = this.objs.find((e) => e.id == id)
            if (obj) this.addToSelected(this.selectedObj)
        },
        unSelectObj(aid) {
            var idx = this.selectedObjs.findIndex((e) => e.id == aid)
            if (idx >= 0) this.selectedObjs.splice(idx, 1)
        },
        confirmSelectedObjs() {
            this.showList = false
            this.$emit('selected', this.selectedIds, this.selectedObjs)
        }
    }
}
</script>
